


















import i18n, { i18n_t } from '@/locales/i18n';

import store from '@/renderer/store';

export default {
  name: 'SpaceIntroduce',
  setup() {
    const { isPrivate } = store.getters;
    const items = [
      {
        title: i18n_t('进度条样式：分配指定额度个人空间'),
        icon: isPrivate
          ? require(`@/renderer/assets/images/Icon/new-icon/space-introduce-6${
              i18n.locale === 'zh-CN' ? '' : '-en'
            }.svg`)
          : require(`@/renderer/assets/images/Icon/new-icon/space-introduce-1${
              i18n.locale === 'zh-CN' ? '' : '-en'
            }.svg`),
      },
      {
        title: i18n_t('无进度条样式：未分配个人空间'),
        icon: isPrivate
          ? require(`@/renderer/assets/images/Icon/new-icon/space-introduce-4${
              i18n.locale === 'zh-CN' ? '' : '-en'
            }.svg`)
          : require(`@/renderer/assets/images/Icon/new-icon/space-introduce-2${
              i18n.locale === 'zh-CN' ? '' : '-en'
            }.svg`),
      },
      {
        title: i18n_t('无进度条样式：共享企业额度'),
        icon: isPrivate
          ? require(`@/renderer/assets/images/Icon/new-icon/space-introduce-5${
              i18n.locale === 'zh-CN' ? '' : '-en'
            }.svg`)
          : require(`@/renderer/assets/images/Icon/new-icon/space-introduce-3${
              i18n.locale === 'zh-CN' ? '' : '-en'
            }.svg`),
      },
    ];

    return { items };
  },
};
